// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__Date from "../../../../util/Date.js";
import * as Buhta_cabinet__Keychain from "../../../../grpc/Keychain.js";
import * as Buhta_cabinet__Link from "../../../html/Link.js";
import * as Buhta_cabinet__LoadingSpinner from "../../../atoms/LoadingSpinner.js";
import * as Buhta_cabinet__SlideOver from "../../../molecules/SlideOver.js";
import * as Buhta_cabinet__Timestamp from "../../../../util/Timestamp.js";
import * as Buhta_core__GrpcState from "../../../../../../../packages/core/lib/GrpcState.js";
import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../../../../packages/util/lib/DateTime.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import PencilSvg from "static/icons/pencil.svg";

function make(id) {
  return function (onClose) {
    const func = Buhta_cabinet__Keychain.CredentialService.view;
    const match = Buhta_core__GrpcState.useModel((function (param) {
            return Curry._3(func, param, {
                        hd: "username",
                        tl: {
                          hd: "password",
                          tl: {
                            hd: "memo",
                            tl: /* [] */0
                          }
                        }
                      }, id);
          }), undefined);
    const dispatch = match[1];
    const model = match[0];
    React.useEffect((function () {
            Curry._2(dispatch, undefined, undefined);
          }), [id]);
    let tmp;
    if (typeof model === "string") {
      tmp = JsxRuntime.jsx(Buhta_cabinet__LoadingSpinner.make, {
            className: "animate-fadeIn"
          });
    } else if (model.NAME === "Data") {
      const item = model.VAL;
      const org = item.org;
      tmp = JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("label", {
                            children: "Организация",
                            className: "block text-sm leading-5 text-gray-500"
                          }),
                      JsxRuntime.jsx("p", {
                            children: org !== undefined ? JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                                    route: {
                                      TAG: /* Admin */7,
                                      _0: {
                                        TAG: /* Orgs */1,
                                        _0: /* Org */{
                                          _0: org.id,
                                          _1: /* Dashboard */0
                                        }
                                      }
                                    },
                                    children: JsxRuntime.jsx("span", {
                                          children: org.name,
                                          className: "text-primary hover:text-primary-lite"
                                        })
                                  }) : null,
                            className: "mt-2 block w-full text-base leading-5"
                          })
                    ]
                  }),
              JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("label", {
                            children: "Логин",
                            className: "block text-sm leading-5 text-gray-500"
                          }),
                      JsxRuntime.jsx("p", {
                            children: item.username !== "" ? item.username : "—",
                            className: "mt-2 block w-full text-base leading-5"
                          })
                    ],
                    className: "mt-6"
                  }),
              JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("label", {
                            children: "Пароль",
                            className: "block text-sm leading-5 text-gray-500"
                          }),
                      JsxRuntime.jsx("p", {
                            children: item.password !== "" ? item.password : "—",
                            className: "mt-2 block w-full text-base leading-5"
                          })
                    ],
                    className: "mt-6"
                  }),
              JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("label", {
                            children: "Пометка",
                            className: "block text-sm leading-5 text-gray-500"
                          }),
                      JsxRuntime.jsx("p", {
                            children: item.memo !== "" ? item.memo : "—",
                            className: "mt-2 block w-full text-base leading-5"
                          })
                    ],
                    className: "mt-6"
                  }),
              JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("label", {
                            children: "Сайт",
                            className: "block text-sm leading-5 text-gray-500"
                          }),
                      JsxRuntime.jsx("p", {
                            children: item.website,
                            className: "mt-2 block w-full text-base leading-5"
                          })
                    ],
                    className: "mt-6"
                  }),
              JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("label", {
                            children: "Истекает в",
                            className: "block text-sm leading-5 text-gray-500"
                          }),
                      JsxRuntime.jsx("p", {
                            children: Belt__Belt_Option.getWithDefault(Belt__Belt_Option.map(item.expire_date, Buhta_cabinet__Date.toString), "—"),
                            className: "mt-2 block w-full text-base leading-5"
                          })
                    ],
                    className: "mt-6"
                  }),
              JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("label", {
                            children: "Создан в",
                            className: "block text-sm leading-5 text-gray-500"
                          }),
                      JsxRuntime.jsx("p", {
                            children: Belt__Belt_Option.getWithDefault(Belt__Belt_Option.map(item.create_time, (function (time) {
                                        return DateTime.toLocalFormat(Buhta_cabinet__Timestamp.toDateTime(time));
                                      })), "—"),
                            className: "mt-2 block w-full text-base leading-5"
                          })
                    ],
                    className: "mt-6"
                  })
            ],
            className: "animate-fadeIn"
          });
    } else {
      console.log("grpc error", model.VAL);
      tmp = "Ошибка: " + "TODO: Unwrap grpc error";
    }
    return JsxRuntime.jsx(Buhta_cabinet__SlideOver.make, {
                title: {
                  TAG: /* Element */1,
                  _0: typeof model === "string" ? JsxRuntime.jsx("span", {
                          children: "Загрузка...",
                          className: "animate-fadeIn"
                        }) : (
                      model.NAME === "Data" ? model.VAL.name : "Не удалось загрузить"
                    )
                },
                actions: {
                  hd: JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                        route: {
                          TAG: /* Admin */7,
                          _0: {
                            TAG: /* Keychain */0,
                            _0: {
                              TAG: /* Credentials */1,
                              _0: {
                                TAG: /* Edit */1,
                                _0: id
                              }
                            }
                          }
                        },
                        children: JsxRuntime.jsx(PencilSvg, {
                              className: "h-5 w-5 text-gray-400 hover:text-gray-500"
                            })
                      }),
                  tl: /* [] */0
                },
                onClose: onClose,
                children: tmp
              });
  };
}

function CredentialItemPreview(Props) {
  return make(Props.id)(Props.onClose);
}

const make$1 = CredentialItemPreview;

export {
  make$1 as make,
}
/* Buhta_cabinet__Date Not a pure module */
